import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import './Home.module.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import { useEffect, useState, useContext } from 'react';
import { MyContext } from './context/UserProvider';
import { useNavigate, useLocation } from 'react-router-dom';
import Preloader from '../layout/Preloader';
import ImageWithLoader from '../layout/ImageWithLoader';
import BackgroundImageWithLoader from '../layout/BackgroundImageWithLoader';
import { AnimatePresence } from 'framer-motion';
import { FiHeart } from "react-icons/fi";

export default function Home() {
  const [anuncio, setAnuncio] = useState({});
  const [produtos, setProdutos] = useState([]);
  const { setScrollY, categorias } = useContext(MyContext);
  const [categoria_id, setCategoriaId] = useState(localStorage.getItem('categoria_id'));
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 700);
  const [hoveredImage, setHoveredImage] = useState(null);
  const [windowDimensions, setWindowDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const urlCategoria = location.pathname.split('/').pop();

    if (urlCategoria && urlCategoria !== categoria_id) {
      setCategoriaId(urlCategoria);
      localStorage.setItem('categoria_id', urlCategoria);
      return;
    }

    if (!categoria_id) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          getAnuncioByCategoriaId(),
          getProdutosByCategorias()
        ]);
        setTimeout(() => setLoading(false), 800);
      } catch (error) {
        console.error("Erro carregando produtos", error);
        setLoading(false);
      }
    };

    fetchData();
    setScrollY(1);
  }, [location.pathname, categoria_id]);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 700);
      setWindowDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!produtos || produtos.length === 0) return;

    produtos.forEach((produto) => {
      const uso = produto?.imagem_uso_url;
      if (uso && uso !== produto?.imagem_url) {
        const img = new Image();
        img.src = uso;
      }
    });
  }, [produtos]);

  const getProdutosByCategorias = async () => {
    const apiBase = process.env.REACT_APP_API_URL;

    const response = await fetch(`${apiBase}/api/getProdutosByCategorias`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ categoria_id }),
    });

    const json = await response.json();

    // Os conjuntos com poltronas já têm o preço final calculado pelo backend.
    // Busca somente esses três preços; não recalcula valores no frontend.
    const produtosComPrecos = await Promise.all(
      (Array.isArray(json) ? json : []).map(async (produto) => {
        if (![27, 30, 31].includes(Number(produto.produto_id))) {
          return produto;
        }

        try {
          const respostaPreco = await fetch(`${apiBase}/api/getInfoProduto`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ produto_id: produto.produto_id }),
          });

          if (!respostaPreco.ok) throw new Error('Consulta de preço indisponível');

          const detalhes = await respostaPreco.json();
          const tamanhoInicial = Number(detalhes.tamanhos?.[0]);
          const precoFinal = Number(detalhes.precos_por_tamanho?.[tamanhoInicial]);

          return {
            ...produto,
            tamanho_inicial_cm: tamanhoInicial || null,
            preco_inicial: Number.isFinite(precoFinal) && precoFinal > 0
              ? precoFinal
              : null,
          };
        } catch (erro) {
          // Nunca mostra o valor incompleto se a consulta falhar.
          console.error('Não foi possível consultar o preço do produto', produto.produto_id);
          return { ...produto, preco_inicial: null };
        }
      })
    );

    setProdutos(Array.isArray(json) ? produtosComPrecos : json);
  };

  const getAnuncioByCategoriaId = async () => {
    const apiBase = process.env.REACT_APP_API_URL;

    const response = await fetch(`${apiBase}/api/getAnuncioByCategoriaId`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ categoria_id }),
    });

    const json = await response.json();
    setAnuncio(json);
  };

  const totalColumns =
    windowDimensions?.width >= 1200
      ? 4
      : windowDimensions?.width >= 768
        ? 3
        : 2;

  const produtosNaUltimaLinha = produtos.length % totalColumns;
  const emptySlots =
    produtos.length > 0 && produtosNaUltimaLinha !== 0
      ? totalColumns - produtosNaUltimaLinha
      : 0;

  return (
    <div
      translate="no"
      style={{
        backgroundColor: '#fff',
        margin: 0,
        padding: 0,
        width: '100%',
        minWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}
    >
      <Navbar />

      <AnimatePresence>
        {loading && <Preloader key="preloader" />}
      </AnimatePresence>

      {anuncio.anuncio_imagem_url && (
        <img
          src={anuncio.anuncio_imagem_url}
          alt={anuncio.anuncio_titulo || 'Anúncio Royal Sofás'}
          style={{
            display: 'block',
            width: '100%',
            height: 'auto',
            marginTop: windowDimensions.width < 700 ? '30px' : 0,
            padding: 0,
            objectFit: 'contain',
          }}
        />
      )}

      <div
        style={{
          position: 'relative',
          width: '100%',
        }}
      >


        <div
          style={{
            position: 'relative',
            width: '100%',
          }}
        >
          {!isDesktop && (
            <div
              style={{
                fontSize: '10px',
                color: '#777',
                textAlign: 'center',
                marginBottom: '6px',
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
              }}
            >
              arraste para ver mais
            </div>
          )}

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              justifyContent: isDesktop ? 'center' : 'center',
              gap: isDesktop ? 8 : 18,
              width: '100%',
              padding: isDesktop ? '0 10px' : '0 12px',
              boxSizing: 'border-box',
              overflowX: !isDesktop ? 'auto' : 'visible',
              overflowY: 'hidden',
              whiteSpace: 'nowrap',
              WebkitOverflowScrolling: 'touch',
              scrollbarWidth: 'none',
            }}
          >
            {categorias.map((categoria) => (
              <div
                key={categoria.categoria_id}
                style={{
                  flex: '0 0 auto',
                  textAlign: 'center',
                  cursor: 'pointer',
                  padding: isDesktop ? '14px 18px' : '10px 4px',
                  transition: 'opacity 0.25s ease, color 0.25s ease',
                  color: '#1f1f1f',
                  letterSpacing: isDesktop ? '0.04em' : '0.02em',
                  textTransform: 'uppercase',
                }}
                onClick={() => {
                  localStorage.setItem('categoria_id', categoria.categoria_id);
                  setCategoriaId(categoria.categoria_id);
                  navigate(`/produtos/${categoria.categoria_id}`);
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = '0.65';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = '1';
                }}
              >
                {isDesktop ? (
                  <h4
                    style={{
                      margin: 0,
                      fontSize: '13px',
                      fontWeight: 400,
                      lineHeight: 1.4,
                    }}
                  >
                    {categoria.categoria_nome}
                  </h4>
                ) : (
                  <h6
                    style={{
                      margin: 0,
                      fontSize: '11px',
                      fontWeight: 400,
                      lineHeight: 1.4,
                    }}
                  >
                    {categoria.categoria_nome}
                  </h6>
                )}
              </div>
            ))}
          </div>

          {!isDesktop && (
            <>
              <div
                style={{
                  position: 'absolute',
                  top: '22px',
                  right: 0,
                  width: '34px',
                  height: '42px',
                  pointerEvents: 'none',
                  background:
                    'linear-gradient(to left, rgba(255,255,255,0.95), rgba(255,255,255,0))',
                }}
              />

              <div
                style={{
                  position: 'absolute',
                  top: '22px',
                  right: '8px',
                  fontSize: '18px',
                  color: '#999',
                  pointerEvents: 'none',
                }}
              >
                ›
              </div>
            </>
          )}
        </div>

        {!isDesktop && (
          <>
            <div
              style={{
                position: 'absolute',
                top: '22px',
                right: 0,
                width: '34px',
                height: '42px',
                pointerEvents: 'none',
                background:
                  'linear-gradient(to left, rgba(255,255,255,0.95), rgba(255,255,255,0))',
              }}
            />

            <div
              style={{
                position: 'absolute',
                top: '22px',
                right: '8px',
                fontSize: '18px',
                color: '#999',
                pointerEvents: 'none',
              }}
            >
              ›
            </div>
          </>
        )}
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            windowDimensions?.width >= 1200
              ? 'repeat(4, 1fr)'
              : windowDimensions?.width >= 768
                ? 'repeat(3, 1fr)'
                : 'repeat(2, 1fr)',
          width: '100%',
        }}
      >
        {produtos.map((produto) => {
          const imagemNormal = produto.imagem_url || '';
          const imagemUso = produto.imagem_uso_url || imagemNormal;
          const hoverKey = `produto_${produto.produto_id}`;
          const currentImage = hoveredImage === hoverKey ? imagemUso : imagemNormal;

          return (
            <div
              key={produto.produto_id}
              style={{
                backgroundColor: '#f5f5f5',
                borderRight: '1px solid #e5e5e5',
                borderBottom: '1px solid #e5e5e5',
                position: 'relative',
                cursor: 'pointer',
              }}
              onClick={() => {
                localStorage.setItem('produto_id', produto.produto_id);
                localStorage.setItem('categoria_id', categoria_id);
                navigate(`/produto/${produto.produto_id}`);
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 13,
                  right: 18,
                  zIndex: 3,
                  lineHeight: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FiHeart
                  size={20}
                  style={{
                    color: "#222",
                    strokeWidth: 1.75,
                    zIndex: 3,
                    transition: "transform 0.28s ease, opacity 0.28s ease, color 0.28s ease",
                  }}
                  onClick={() => {
                    console.log('adicionado a lista de desejos');
                  }}
                  className="lv-heart-icon"
                />
              </div>

              <div
                style={{
                  width: '100%',
                  aspectRatio: '4 / 3',
                  backgroundImage: `url(${currentImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  position: 'relative',
                  overflow: 'hidden',
                }}
                onMouseEnter={() => {
                  setHoveredImage(hoverKey);
                }}
                onMouseLeave={() => {
                  setHoveredImage(null);
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: 8,
                    right: 8,
                    bottom: 8,
                    top: windowDimensions?.width < 408 ? 8 : 'auto',
                    zIndex: 2,
                    color: '#111',
                  }}
                >
                  <div
                    style={{
                      fontSize: 'clamp(10px, 0.9vw, 14px)',
                      fontWeight: 400,

                      position: windowDimensions?.width < 408 ? 'absolute' : 'static',
                      top: windowDimensions?.width < 408 ? 0 : 'auto',
                      left: windowDimensions?.width < 408 ? 0 : 'auto',
                    }}
                  >
                    {produto.produto_nome}
                  </div>

                  {produto.preco_inicial != null &&
                    produto.preco_inicial !== '' && (
                      <div
                        style={{
                          marginTop: windowDimensions?.width < 408 ? 0 : 4,

                          position: windowDimensions?.width < 408 ? 'absolute' : 'static',
                          bottom: windowDimensions?.width < 408 ? 0 : 'auto',
                          left: windowDimensions?.width < 408 ? 0 : 'auto',
                          right: windowDimensions?.width < 408 ? 0 : 'auto',

                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 8,
                          fontSize: windowDimensions?.width >= 768 ? 11 : 10,
                          color: '#555',
                        }}
                      >
                        <span>
                          {Number(produto.preco_inicial).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </span>

                        {produto.tamanho_inicial_cm != null && (
                          <span>
                            {produto.tamanho_inicial_cm} cm
                          </span>
                        )}
                      </div>
                    )}
                </div>
              </div>
            </div>
          );
        })}

        {emptySlots > 0 && (
          <div
            style={{
              gridColumn: `span ${emptySlots}`,
              backgroundColor: '#f5f5f5',
              borderRight: '1px solid #e5e5e5',
              borderBottom: '1px solid #e5e5e5',
              position: 'relative',
              overflow: 'hidden',
              aspectRatio: `${emptySlots * 4} / 3`,
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: 0,
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding:
                  windowDimensions?.width < 400
                    ? '8px'
                    : emptySlots === 1
                      ? windowDimensions?.width >= 1200
                        ? '20px'
                        : windowDimensions?.width >= 768
                          ? '16px'
                          : '12px'
                      : windowDimensions?.width >= 1200
                        ? '28px'
                        : windowDimensions?.width >= 768
                          ? '22px'
                          : '16px',
                boxSizing: 'border-box',
                background: 'linear-gradient(135deg, #f7f7f5 0%, #ece9e3 100%)',
              }}
            >
              <div
                style={{
                  textAlign: 'center',
                  maxWidth: windowDimensions?.width < 400 ? '96%' : emptySlots === 1 ? '92%' : '78%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap:
                    windowDimensions?.width < 400
                      ? 3
                      : emptySlots === 1
                        ? windowDimensions?.width >= 1200
                          ? 8
                          : windowDimensions?.width >= 768
                            ? 6
                            : 5
                        : windowDimensions?.width >= 1200
                          ? 10
                          : windowDimensions?.width >= 768
                            ? 8
                            : 6,
                }}
              >
                <div
                  style={{
                    fontSize:
                      windowDimensions?.width < 400
                        ? 7
                        : emptySlots === 1
                          ? windowDimensions?.width >= 1200
                            ? 10
                            : windowDimensions?.width >= 768
                              ? 9
                              : 8
                          : windowDimensions?.width >= 1200
                            ? 11
                            : windowDimensions?.width >= 768
                              ? 10
                              : 9,
                    color: '#7a746b',
                    fontWeight: 500,
                    letterSpacing: windowDimensions?.width < 400 ? '0.12em' : '0.18em',
                    textTransform: 'uppercase',
                    lineHeight: 1.1,
                  }}
                >
                  Royal Estofados
                </div>

                <div
                  style={{
                    fontSize:
                      windowDimensions?.width < 360
                        ? 10
                        : windowDimensions?.width < 400
                          ? 11
                          : emptySlots === 1
                            ? windowDimensions?.width >= 1200
                              ? 22
                              : windowDimensions?.width >= 768
                                ? 17
                                : 14
                            : windowDimensions?.width >= 1200
                              ? 28
                              : windowDimensions?.width >= 768
                                ? 22
                                : 17,
                    color: '#111',
                    fontWeight: 400,
                    lineHeight: windowDimensions?.width < 400 ? 1.02 : 1.12,
                    letterSpacing: '-0.02em',
                  }}
                >
                  Sofás pensados para transformar o ambiente
                </div>

                <div
                  style={{
                    width: windowDimensions?.width < 400 ? 28 : 42,
                    height: 1,
                    backgroundColor: '#cfc8bc',
                    margin: windowDimensions?.width < 400 ? 0 : '1px 0',
                  }}
                />

                <div
                  style={{
                    fontSize:
                      windowDimensions?.width < 360
                        ? 7
                        : windowDimensions?.width < 400
                          ? 8
                          : emptySlots === 1
                            ? windowDimensions?.width >= 1200
                              ? 11
                              : windowDimensions?.width >= 768
                                ? 10
                                : 9
                            : windowDimensions?.width >= 1200
                              ? 13
                              : windowDimensions?.width >= 768
                                ? 12
                                : 10,
                    color: '#4f4a43',
                    fontWeight: 400,
                    lineHeight: windowDimensions?.width < 400 ? 1.25 : 1.45,
                    maxWidth: 420,
                  }}
                >
                  Conforto, presença e elegância em modelos que valorizam sua casa com estética sofisticada.
                </div>

                <div
                  style={{
                    marginTop: windowDimensions?.width < 400 ? 1 : 4,
                    padding:
                      windowDimensions?.width < 360
                        ? '5px 7px'
                        : windowDimensions?.width < 400
                          ? '6px 8px'
                          : emptySlots === 1
                            ? windowDimensions?.width >= 768
                              ? '8px 12px'
                              : '7px 10px'
                            : windowDimensions?.width >= 768
                              ? '10px 18px'
                              : '8px 12px',
                    border: '1px solid #d8d2c7',
                    color: '#1f1f1f',
                    fontSize:
                      windowDimensions?.width < 400
                        ? 7
                        : emptySlots === 1
                          ? windowDimensions?.width >= 1200
                            ? 9
                            : windowDimensions?.width >= 768
                              ? 8
                              : 8
                          : windowDimensions?.width >= 1200
                            ? 11
                            : windowDimensions?.width >= 768
                              ? 10
                              : 9,
                    letterSpacing: windowDimensions?.width < 400 ? '0.08em' : '0.14em',
                    textTransform: 'uppercase',
                    backgroundColor: 'rgba(255,255,255,0.45)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Descubra sua coleção
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}